var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFromGallery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.853 18.066h-17.7a1.149 1.149 0 01-1.148-1.148V3.148A1.149 1.149 0 011.153 2h17.7a1.149 1.149 0 011.148 1.148v13.771a1.149 1.149 0 01-1.148 1.147zM1.153 2.984a.166.166 0 00-.164.164v13.771a.166.166 0 00.164.164h17.7a.166.166 0 00.164-.164V3.148a.166.166 0 00-.164-.164z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.504 16.23a.489.489 0 01-.352-.149l-4.607-4.73-2.93 2.344a.492.492 0 01-.655-.036L6.048 8.747.821 13.563a.492.492 0 11-.667-.723l5.574-5.136a.493.493 0 01.681.014l4.934 4.935 2.935-2.348a.491.491 0 01.659.041l4.918 5.049a.491.491 0 01-.352.835zm-5.24-8.323A1.148 1.148 0 1115.41 6.76a1.149 1.149 0 01-1.146 1.147zm0-1.311a.164.164 0 100 .328.164.164 0 000-.328z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromGallery);
export default __webpack_public_path__ + "static/media/from_gallery.40e8b0c436c772c9c679e5e4bf662522.svg";
export { ForwardRef as ReactComponent };